export default {
    getByProjects: (state) => {
        if (state.report && state.report.byProject) {
            return state.report.byProject
        }
        return []
    },
    getDtpQueries: (state) => {
        return state.dtpQueries
    },
    getSelectedQueryProject: (state) => {
        return state.selectedQueryProject
    },
    getSelectedQuerySite: (state) => {
        return state.selectedQuerySite
    },
    getQueryData: (state) => {
        return state.searchQueryData
    },
    getQueryDataSites: (state) => {
        return state.searchQueryDataSites
    },
    getFilteredQueryProjects: (state, getters) => {
        if (state.report.byProject && state.report.byProject.length > 0) {
            let filteredProjects = JSON.parse(JSON.stringify(state.report.byProject))

            filteredProjects = filteredProjects.filter(project => project._id != null)

            if (state.searchQueryData.query.length > 0) {
                filteredProjects = filteredProjects.filter(project => project.name.toLowerCase().includes(state.searchQueryData.query.toLowerCase()))
            }
            return filteredProjects
        }

        return []
    },

    getFilteredQuerySites: (state, getters) => {
        if (state.report.bySite && state.report.bySite.length > 0) {
            let filteredSites = JSON.parse(JSON.stringify(state.report.bySite))

            filteredSites = filteredSites.filter(site => site._id != null)


            const searchTerm = state.searchQueryDataSites.query.toLowerCase();

            filteredSites = filteredSites.filter(site => {
                const nameMatches = site.name.toLowerCase().includes(searchTerm);
                const codeMatches = site.clientSiteCodes?.some(code =>
                    code.toLowerCase().includes(searchTerm)
                );

                return nameMatches || codeMatches;
            });

            return [...filteredSites]
        }

        return []
    },
    getReport: (state, getters) => {
        return state.report
    }
}
